import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/logo_no_shadow.png'


const _hoisted_1 = { class: "destroy-success-con" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "destroy-title" }, "账号已注销", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "destroy-success-main" }, [
  /*#__PURE__*/_createElementVNode("p", null, "感谢您对「好未来图书」App 的使用和支持！"),
  /*#__PURE__*/_createElementVNode("p", null, "期待下次与您更好的相遇"),
  /*#__PURE__*/_createElementVNode("p", null, "如需再次使用，请重新注册")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", {
      class: "confirm-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goNativeLogin()))
    }, "知道了")
  ]))
}